import { render } from "./P083.vue?vue&type=template&id=dbfb57ba&scoped=true"
import script from "./P083.vue?vue&type=script&lang=js"
export * from "./P083.vue?vue&type=script&lang=js"

import "./P083.vue?vue&type=style&index=0&id=dbfb57ba&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfb57ba"]])

export default __exports__